const WHATSAPP_NUMBER = "61409521554";
const WHATSAPP_MESSAGE =
  "Hello TAK8 Car Rental team, I would like help with a car rental booking.";

const WhatsAppContactButton = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_MESSAGE
  )}`;

  return (
    <a
      className="WhatsAppContactButton"
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with the TAK8 Car Rental team on WhatsApp"
      title="Chat with TAK8 Car Rental on WhatsApp"
      data-analytics-name="WhatsApp - Global Contact Button"
    >
      <span className="WhatsAppContactButtonIcon" aria-hidden="true">
        <svg viewBox="0 0 32 32" role="img">
          <path
            fill="currentColor"
            d="M16.04 3C8.85 3 3 8.73 3 15.78c0 2.48.72 4.9 2.1 6.98L3 29l6.45-2.04a13.2 13.2 0 0 0 6.58 1.75H16c7.18 0 13-5.74 13-12.8C29 8.74 23.2 3 16.04 3Zm0 23.55h-.01a11 11 0 0 1-5.62-1.52l-.4-.23-3.83 1.21 1.25-3.67-.26-.42a10.5 10.5 0 0 1-1.7-5.73c0-5.96 4.74-10.81 10.58-10.81 2.82 0 5.47 1.11 7.47 3.13a10.77 10.77 0 0 1 3.1 7.67c0 5.96-4.74 10.81-10.58 10.81Zm5.8-8.1c-.32-.16-1.88-.94-2.17-1.05-.29-.1-.5-.16-.71.16-.21.32-.82 1.05-1 1.27-.19.21-.37.24-.69.08-.32-.16-1.34-.5-2.55-1.6a9.6 9.6 0 0 1-1.76-2.22c-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.71-1.73-.98-2.37-.26-.62-.52-.54-.71-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.1-1.11 2.68s1.14 3.11 1.3 3.32c.16.21 2.24 3.47 5.43 4.87.76.33 1.35.52 1.81.67.76.25 1.45.21 2 .13.61-.09 1.88-.78 2.14-1.53.26-.75.26-1.4.18-1.53-.08-.14-.29-.21-.61-.37Z"
          />
        </svg>
      </span>
      <span className="WhatsAppContactButtonText">
        <small>Need help?</small>
        Chat on WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppContactButton;
